<mat-accordion>
  <mat-expansion-panel (opened)="refreshLocations()">
    <mat-expansion-panel-header>
      <mat-panel-title>Selector tenant</mat-panel-title>
    </mat-expansion-panel-header>

    <div class="tenant-selector" *ngIf="configService.settings as settings">
      <div class="tenant-logo">
        <img
          [alt]="settings.name"
          [src]="settings.logo.imageMedium"
          [srcset]="
            settings.logo.imageSmall + ' 200w, ' +
            settings.logo.imageMedium + ' 400w, ' +
            settings.logo.imageLarge + ' 800w'
          "
        />
      </div>

      <mat-form-field appearance="outline" class="tenant-select-field">
        <mat-label>Instalacion</mat-label>
        <mat-select
          [disabled]="loading || locations.length === 0"
          [ngModel]="selectedLocationCode"
          (ngModelChange)="onLocationChange($event)"
        >
          <mat-select-trigger>
            <span class="location-option" *ngIf="selectedLocation as location">
              <mat-icon [class.offline]="!location.online" [class.online]="location.online">
                {{ location.online ? 'link' : 'link_off' }}
              </mat-icon>
              <span [class.offline]="!location.online" [class.online]="location.online">
                {{ location.locationCode }}
              </span>
            </span>
          </mat-select-trigger>

          <mat-option *ngFor="let location of locations" [value]="location.locationCode">
            <span class="location-option">
              <mat-icon [class.offline]="!location.online" [class.online]="location.online">
                {{ location.online ? 'link' : 'link_off' }}
              </mat-icon>
              <span [class.offline]="!location.online" [class.online]="location.online">
                {{ location.locationCode }}
              </span>
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-expansion-panel>
</mat-accordion>
